import { surveyLocalization } from "survey-core";
import "survey-core/i18n/spanish";
import "survey-core/i18n/german";

export const SUPPORTED_SURVEY_LOCALES = ["en", "es", "de"];

/**
 * Initialize SurveyJS localization. Call once at app startup.
 */
export function initSurveyLocalization() {
  surveyLocalization.supportedLocales = SUPPORTED_SURVEY_LOCALES;
}

/**
 * Return locale if supported, otherwise fall back to "en".
 */
export function getSafeLocale(locale) {
  if (locale && SUPPORTED_SURVEY_LOCALES.includes(locale)) return locale;
  return "en";
}

/**
 * Normalize a survey JSON so plain string fields become localization objects.
 * Safe to call on any JSON — strings become { default: "..." }, objects pass through.
 * Use before saving if you want to guarantee multi-language structure.
 */
export function normalizeSurveyLocalization(json) {
  if (!json || typeof json !== "object") return json;

  const toLocaleObj = (value) => {
    if (typeof value === "string") return { default: value };
    return value;
  };

  const normalizeQuestion = (q) => {
    if (!q || typeof q !== "object") return q;
    const result = { ...q };
    if (typeof result.title === "string") result.title = toLocaleObj(result.title);
    if (typeof result.description === "string")
      result.description = toLocaleObj(result.description);
    if (typeof result.placeholder === "string")
      result.placeholder = toLocaleObj(result.placeholder);
    if (Array.isArray(result.choices)) {
      result.choices = result.choices.map((c) => {
        if (typeof c === "object" && c !== null && typeof c.text === "string") {
          return { ...c, text: toLocaleObj(c.text) };
        }
        return c;
      });
    }
    return result;
  };

  const normalizePage = (page) => {
    if (!page || typeof page !== "object") return page;
    const p = { ...page };
    if (typeof p.title === "string") p.title = toLocaleObj(p.title);
    if (Array.isArray(p.elements)) p.elements = p.elements.map(normalizeQuestion);
    return p;
  };

  const result = { ...json };
  if (typeof result.title === "string") result.title = toLocaleObj(result.title);
  if (typeof result.description === "string") result.description = toLocaleObj(result.description);
  if (Array.isArray(result.pages)) result.pages = result.pages.map(normalizePage);
  if (Array.isArray(result.elements)) result.elements = result.elements.map(normalizeQuestion);
  return result;
}
